module.exports = __webpack_public_path__ + "img/vape-shop-custom-website.39d03613.webp";